const car_64 = "x64"; //车辆架构型号
const car_86 = "x86";
const car_arm = "arm";
const car_arm64 = "arm64";

const car_status_automaticsupplying = "9"; //自动补给中
const car_status_tosupply = "21"; //前往补给
const car_status_stop = "22"; //前往停靠
const car_status_supplying = "23"; //补给中

const role_type_agent = 1; //代理商id
const role_type_enduser = 2; //终端用户id

export {
  car_64,
  car_86,
  car_arm,
  car_arm64,
  car_status_automaticsupplying,
  car_status_tosupply,
  car_status_stop,
  car_status_supplying,
  role_type_agent,
  role_type_enduser,
};
